import { Pin as PinGlobal } from 'app/common/components/Cafeteria/CafeteriaSettings'


type Props = {
  accountID: string
}

export const Pin = ({ accountID }: Props) => {
  // TODO Вынести сюда баннер

  return (
    <PinGlobal customerID={accountID} />
  )
}
